import { render } from "./edit.vue?vue&type=template&id=f2aeacc2"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__